<template>
  <sign-page
    ref="page"
    title-text="发票管理"
    :request="request"
    v-loading="loading"
    :column-list="columnList"
    table-size="small"
    :initAddFormData="initAddFormData"
    :onFormChange="onFormChange"
    :dealFormData="dealFormData"
    @dataFileUpdate="dataFileUpdate"
    :title-menus="[{key: 'add', label: '新增'}, {key: 'export', label: '导出'}]"
    @clickTitleMenu="clickTitleMenu"
    :table-actions="tableActions"
    :table-actions-width="380"
    @tableAction="tableAction"
    :form-parms-add="formParms"
    :form-parms-update="formParms"
    :table-actions-fixed="true"
    table-border
    :need-data-file="true">
    <fm-modal v-model="openRecord" width="90%" :title="'系统校验记录（' + chooseData.code + ' ' + chooseData.codeNum + '）'">
      <div style="width: 100%;" v-if="openRecord">
      <fm-table-new
        :columns="columns"
        border="row"
        :data-list="checkRecordList"
        :stripe="false"
        emptyPlaceholder="-">
      </fm-table-new>
    </div>
    </fm-modal>
  </sign-page>
</template>

<script>
import {
  billRequest as request
} from '../../api'

import { createWorkbook, bookAppendSheet, aoaToSheet, downloadExcelWithStyle, setWorkbookBaseStyle, setWorksheetCellStyle } from '@/components/excel/lib'

const billTypes = [
  { key: 1, label: '数电票' },
  { key: 2, label: '财政票据' },
  { key: 3, label: '增值税专用发票' },
  { key: 4, label: '增值税普通发票' },
  { key: 5, label: '增值税电子普通发票' },
  { key: 6, label: '广东通用机打发票' },
  { key: 7, label: '浙江通用（电子）发票' },
  { key: 10, label: '深圳区块链发票' },
]

export default {
  computed: {
    columns () {
      return [{
        title: '校验时间',
        field: 'createTime',
        width: 100,
        fixed: 'left',
        render: (h, rowData) => {
          return h('div', rowData && rowData.createTime ? rowData.createTime.slice(0, 10) : '-')
        }
      },
      {
        title: '操作人',
        width: 70,
        fixed: 'left',
        field: 'userName'
      },
      {
        title: '发票代码',
        width: 120,
        fixed: 'left',
        field: 'code'
      },
      {
        title: '发票号码',
        width: 100,
        fixed: 'left',
        field: 'codeNum'
      },
      {
        title: '税前金额',
        width: 100,
        field: 'amount'
      },
      {
        title: '总金额',
        width: 100,
        field: 'total'
      },
      {
        title: '开票日期',
        width: 100,
        field: 'billTime',
        render: (h, rowData) => {
          return h('div', rowData && rowData.billTime ? rowData.billTime.slice(0, 10) : '-')
        }
      },
      {
        title: '发票校验码',
        field: 'codeCheck'
      },
      {
        title: '真伪验证结果',
        field: 'isPass'
      },
      {
        title: '提示信息',
        field: 'resultMsg'
      },
      {
        title: '返回税前金额',
        field: 'checkAmount'
      },
      {
        title: '返回总金额',
        field: 'checkTotal'
      }]
    },
    tableActions () {
      let data = [{
        key: 'data_file',
        label: '扫描件'
      },
      {
        key: 'check',
        label: '系统校验',
        show: (data) => {
          return data.checkStatus !== 'pass'
        }
      },
      {
        key: 'manual_check',
        label: '人工校验',
        show: (data) => {
          return data.checkStatus !== 'pass'
        }
      },
      {
        key: 'check_record',
        label: '系统校验记录'
      },
      {
        key: 're_check',
        label: '重新校验',
        show: (data) => {
          return data.checkStatus === 'pass'
        }
      },
      {
        key: 'edit',
        label: '修改',
        show: (data) => {
          return data.checkStatus !== 'pass'
        }
      },
      {
        key: 'del',
        label: '删除'
      }]
      return data
    },
    formParms: {
      get () {
        let data = [{
          type: 'input',
          label: '发票代码',
          key: 'code',
          check: {
            required: true
          }
        },
        {
          type: 'input',
          label: '发票号码',
          key: 'codeNum',
          check: {
            required: true
          }
        },
        {
          type: 'select',
          label: '发票类型',
          key: 'type',
          check: {
            required: true
          },
          selectDatas: billTypes
        },
        {
          type: 'input',
          label: '税前金额',
          key: 'amount',
          check: {
            rules: {
              type: 'number'
            }
          }
        },
        {
          type: 'input',
          label: '税率',
          key: 'rate',
          check: {
            rules: {
              type: 'number'
            }
          }
        },
        {
          type: 'input',
          label: '总金额',
          key: 'total',
          check: {
            rules: {
              type: 'number'
            }
          }
        },
        {
          type: 'datePicker',
          label: '开票日期',
          key: 'billTime'
        },
        {
          type: 'input',
          label: '纳税人识别号（销售方）',
          key: 'xfsbh'
        },
        {
          type: 'datePicker',
          label: '新增日期',
          key: 'addTime'
        },
        {
          type: 'input',
          label: '发票校验码',
          key: 'codeCheck'
        },
        {
          type: 'input',
          label: '发票来源',
          key: 'source'
        },
        {
          type: 'input',
          label: '货物或应税劳务、服务名称',
          key: 'projectName'
        },
        {
          type: 'textarea',
          label: '备注',
          key: 'remark'
        }]
        return data
      }
    },
    columnList () {
      let data = this.formParms.map(v => {
        let item = {
          title: v.label,
          field: v.key,
          sort: true
        }
        if (v.type === 'datePicker') {
          item.render = (h, rowData) => {
            return h('div', rowData && rowData[v.key] ? rowData[v.key].slice(0, 10) : '-')
          }
          item.width = 220
          item.dataType = Date
          item.filterRange = true
        }
        if (v.key === 'type') {
          item.render = (h, row) => {
            let type = billTypes.find(v => v.key === row.type)
            return h('div', type ? type.label : '-')
          }
        }
        return item
      })
      data.push({
        title: '校验状态',
        field: 'checkStatusLabel'
      })
      return data
    }
  },
  methods: {
    clickTitleMenu (key) {
      if (key === 'export') {
        this.exportData()
      }
    },
    exportData () {
      const dataList = this.$refs.page.dataList

      const dateFormat = (value) => {
        return value ? this.$datetime.format(value, 'Y-M-D') : ''
      }

      const typeFormat = (value) => {
        let type = billTypes.find(v => v.key === value)
        return type ? type.label : ''
      }

      const fields = this.formParms.map(v => {
        let item = { label: v.label, key: v.key }
        if (v.type === 'datePicker') {
          item.format = dateFormat
        }
        if (v.key === 'type') {
          item.format = typeFormat
        }
        return item
      })
      fields.push({
        label: '校验状态',
        key: 'checkStatusLabel'
      })

      const workbook = createWorkbook()
      const worksheet = aoaToSheet([
        fields.map(v => v.label),
        ...dataList.map(item => {
          return fields.map((v) => {
            if (typeof v.format === 'function') {
              return v.format(item[v.key])
            } else {
               return item[v.key]
            }
          })
        })
      ])

      bookAppendSheet(workbook, worksheet, 'Sheet1')

      const blackBorder = {
        top: {style: 'thin', color: {rgb: '000000'}},
        bottom:	{style: 'thin', color: {rgb: '000000'}},
        left:	{style: 'thin', color: {rgb: '000000'}},
        right: {style: 'thin', color: {rgb: '000000'}}
      }

      // 设置表格基础样式
      setWorkbookBaseStyle(workbook, {
        font: {
          name: '宋体',
          sz: 10
        },
        border: blackBorder
      })

      // 字段名加粗
      fields.forEach((v, i) => {
        setWorksheetCellStyle(worksheet, [[0, i]], {
          font: {
            bold: true,
            name: '宋体',
            sz: 12
          },
          border: blackBorder
        })
      })

      downloadExcelWithStyle(workbook)
    },
    async tableAction (parm, vm) {
      if (parm.action === 'check_record') {
        this.openRecord = true
        this.chooseData = parm.data
        this.loadCheck()
        return
      }
      let aLabel = this.tableActions.find(v => v.key === parm.action).label
      const confirm = await this.$dialog.confirm({ title: '提示', content: '确定对该发票进行' + aLabel + '吗?' })
      if (confirm) {
        this.loading = true
        if (parm.action === 'check') {
          try {
            let data = await request.check(parm.data.id)
            if (data.resultCode === 'match') {
              this.$notice.success({ title: data.resultMsg})
            } else {
              this.$dialog.confirm({ title: '系统提示', content: data.resultMsg })
            }
          } catch (e) {
            console.log(e)
          }
        } else if (parm.action === 'manual_check') {
          await request.manualCheck(parm.data.id, {
            checkStatus: 'pass'
          })
          this.$notice.success({ title: aLabel + '完成'})
        } else if (parm.action === 're_check') {
          await request.manualCheck(parm.data.id, {
            checkStatus: 'wait'
          })
          this.$notice.success({ title: aLabel + '完成'})
        }
        this.loading = false
        vm.loadData()
      }
    },
    async loadCheck () {
      this.checkRecordList = []
      let parm = {
        billId: this.chooseData.id
      }
      let datas = await request.getCheck(parm)
      datas.forEach(v => {
        v.isPass = v.resultCode === 'match' ? '校验通过' : '校验未通过，请进一步核实'
      })
      this.checkRecordList = datas
    },
    async loadData (parm) {
      let datas = await request.get(parm)
      datas.forEach(v => {
        v.checkStatusLabel = null
        if (v.checkStatus === 'pass') {
          if (v.billCheckId) {
            v.checkStatusLabel = '校验通过(系统)'
          } else {
            v.checkStatusLabel = '校验通过(人工)'
          }
        } else if (v.checkStatus === 'fail') {
            v.checkStatusLabel = '系统校验失败'
        } else {
          v.checkStatusLabel = '未校验'
        }
      })
      return datas
    },
    dealFormData (data) {
      let dealKeys = ['amount', 'rate', 'total']
      dealKeys.forEach(v => {
        if (typeof data[v] === 'string') {
          data[v] = data[v].replaceAll(' ', '')
          if (data[v] === '') {
            data[v] = null
          }
        }
      })
      return data
    },
    async dataFileUpdate (parm, pageVm) {
      await request.update(pageVm.chooseData.id, {
        fileIds: parm && parm.length > 0 ? parm.join(',') : null
      })
      pageVm.loadData()
    },
    initAddFormData () {
      return {
        addTime: new Date()
      }
    },
    onFormChange (key, value, formData) {
      if (['rate', 'amount'].includes(key)) {
        let rate = Number(formData['rate'])
        let amount = Number(formData['amount'])
        if (!isNaN(rate) && !isNaN(amount) && formData['amount']) {
          return {
            total: Number((amount * (rate + 1)).toFixed(2))
          }
        } else {
          return {
            total: 0
          }
        }
      }
    },
  },
  data () {
    return {
      loading: false,
      chooseData: {},
      openRecord: false,
      checkRecordList: [],
      request: Object.assign({}, request, {
        get: this.loadData
      })
    }
  }
}
</script>
